import React from "react";
import {
    Table, Input, Button, Form, Divider
} from 'antd';
import { ColumnProps } from "antd/lib/table";

import { EuColModel, EuGridOptions, EuPageService, CURDAction, EuModalService, BaseAction, ModalConfig } from "easyui-core";
import { DndProvider, DragSource, DropTarget } from 'react-dnd';
// import update from 'immutability-helper';
import HTML5Backend from 'react-dnd-html5-backend';

import { ModalService } from "../modal/ModalService";

export class AntTable extends React.Component<
    {
        columns: EuColModel[],
        gridOptions: EuGridOptions,
        pageService: EuPageService,
        modalService?: EuModalService,
        rowSelection?: {},
        reload?: Function,
    },
    {
        data: Array<any>,
        total: number,
        pagination: any,
        loading: boolean
        selectedRowKeys: any[]
    }
    > {

    columns: (ColumnProps<any> & {
        editable: boolean
    })[] = []

    url: any
    gridOptions: EuGridOptions
    pageService: EuPageService
    modalService: EuModalService


    actions: BaseAction[]
    normalActions: BaseAction[] = []
    inlineActions: BaseAction[] = []
    defaultActionModalConfig: ModalConfig | undefined

    constructor(props) {
        super(props);
        let initData = []
        if (props.gridOptions.initData) {
            initData = props.gridOptions.initData
        }
        this.url = this.props.gridOptions.url
        this.gridOptions = this.props.gridOptions
        this.state = {
            selectedRowKeys: [],
            loading: false,
            data: initData,
            total: 0,
            pagination: {
                pageSize: this.gridOptions.rowNum
            }
        }

        this.columns = this.props.columns.map((col) => {
            return {
                title: col.title,
                dataIndex: col.field,
                render: col.render ? col.render.bind(this) : null,
                editable: !!col.editable,
                sortDirections: ['descend'],
            }
        })
        this.pageService = props.pageService
        this.modalService = props.modalService == null ? ModalService : props.modalService
        this.defaultActionModalConfig = this.props.gridOptions.defaultActionModalConfig;
        this.setActions(this.props.gridOptions.actions)
    }

    setActions(actions: BaseAction[] | undefined) {
        if (actions) {
            for (let index = 0; index < actions.length; index++) {
                const element = actions[index];
                if (element.type === "normal") {
                    this.normalActions.push(element)
                } else if (element.type === "inline") {
                    this.inlineActions.push(element)
                }
            }
        }
    }

    // static getDerivedStateFromProps(props, states) {

    // }

    componentDidMount() {
        this.fetchData(this.gridOptions.rowNum, 1)
    }

    curSize: number = 10
    curIndex: number = 1
    fetchData(
        pageSize?: number | undefined,
        pageIndex?: number | undefined
    ) {
        this.setState({
            loading: true
        })
        let size = pageSize || this.curSize
        let index = pageIndex || this.curIndex
        this.pageService.getPage(this.url, size, index).then(data => {
            debugger
            const pagination = { ...this.state.pagination };
            // Read total count from server
            // pagination.total = data.totalCount;
            pagination.total = data.total;
            this.setState({
                loading: false,
                data: data.contents,
                pagination: pagination
            })
        })
    }

    handleTableChange = (pagination, filters, sorter) => {
        const pager: any = { ...this.state.pagination };
        pager.current = pagination.current;
        this.setState({
            pagination: pager,
        });
        this.curIndex = pagination.current
        this.curSize = pagination.pageSize
        this.fetchData(pagination.pageSize, pagination.current,
            // sortField: sorter.field,
            // sortOrder: sorter.order,
            // ...filters,
        );

    }

    handleDelete = (key) => {
        const data = [...this.state.data];
        const newDatas = data.filter(item => item.key !== key)
        this.setState({ data: newDatas });

    }

    handleAdd = () => {
        const { total, data } = this.state;
        const newData = {
            key: total,
            name: `name ${total}`,
            age: 32,
            address: `addr. ${total}`,
        };
        let newdatas = [...data, newData];
        this.setState({
            data: newdatas,
            total: total + 1,
        });

    }

    handleSave = (row) => {
        const newData = [...this.state.data];
        const index = newData.findIndex(item => row.key === item.key);
        const item = newData[index];
        newData.splice(index, 1, {
            ...item,
            ...row,
        });
        this.setState({
            data: newData
        });
    }

    onSelectChange = selectedRowKeys => {
        console.log('selectedRowKeys changed: ', selectedRowKeys);
        this.setState({ selectedRowKeys });
    };

    onRow = (record: any) => {
        return {
            onClick: event => {
                if (this.gridOptions.onRowClick) {
                    this.gridOptions.onRowClick(record[this.gridOptions.primaryKey], record, undefined)
                }
            }, // 点击行
            onDoubleClick: event => {
                if (this.gridOptions.onRowDoubleClick) {
                    this.gridOptions.onRowDoubleClick(record[this.gridOptions.primaryKey], record, undefined)
                }
            },
            onContextMenu: event => {
                if (this.gridOptions.onRowContextMenu) {
                    this.gridOptions.onRowContextMenu(record[this.gridOptions.primaryKey], record, undefined)
                }
            },
            onMouseEnter: event => {
                if (this.gridOptions.onRowMouseEnter) {
                    this.gridOptions.onRowMouseEnter(record[this.gridOptions.primaryKey], record, undefined)
                }
            }, // 鼠标移入行
            onMouseLeave: event => {
                if (this.gridOptions.onRowMouseLeave) {
                    this.gridOptions.onRowMouseLeave(record[this.gridOptions.primaryKey], record, undefined)
                }
            },
        }
    }

    render() {
        const { data } = this.state;
        const components = {
            body: {
                row: this.props.gridOptions.rowDragManaged ? DragableFormRow : EditableFormRow,
                cell: EditableCell,
            },
        };

        const columns = this.columns.map((col) => {
            if (!col.editable) {
                return col;
            }
            return {
                ...col,
                onCell: record => ({
                    record,
                    editable: col.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: this.handleSave,
                }),
            };
        });

        if (this.inlineActions.length > 0) {


            columns.push({
                title: "操作",
                render: (text, data, index) => {
                    const inlineActionItems = this.inlineActions.map((action, index, all) => (
                        <>
                            <a href="javascript:;" onClick={e => { this.handleAction(action, text, data, index) }}>{action.name}</a>
                            {index == all.length - 1 ? <></> : <Divider type="vertical" />}
                        </>
                    ))
                    return (
                        <span>
                            {inlineActionItems}
                        </span>
                    )
                },
                editable: false
            })

        }
        let normalActionItems = new Array()
        if (this.normalActions.length > 0) {
            normalActionItems = this.normalActions.map((action, index, all) => {
                debugger
                return (
                    <>
                        <Button icon={action.icon} onClick={e => { this.handleAction(action) }} type="primary" style={{ marginBottom: 16, marginRight: 16 }}>
                            {action.name}
                        </Button>
                    </>
                )
            })
        }
        const { loading, selectedRowKeys } = this.state;
        // const rowSelection = {
        //     selectedRowKeys,
        //     onChange: this.onSelectChange,
        // };
        const rowSelection = this.props.rowSelection ? this.props.rowSelection : undefined


        return (
            <div>
                {/* <Button onClick={this.handleAdd} type="primary" style={{ marginBottom: 16 }}>
                    Add a row
                </Button> */}
                {normalActionItems}
                <DndProvider backend={HTML5Backend}>
                    <Table
                        onRow={this.onRow}
                        components={components}
                        rowClassName={() => 'editable-row'}
                        pagination={this.state.pagination}
                        bordered
                        dataSource={data}
                        columns={columns}
                        onChange={this.handleTableChange}
                        loading={this.state.loading}
                        rowSelection={rowSelection}
                    />
                </DndProvider>
            </div>
        );
    }

    handleAction(action: BaseAction, text?, data?, index?) {
        let type = CURDAction.TYPE_READ
        let curdType = (action as CURDAction).curdType;
        let component = action.modalConfig ?
            action.modalConfig.component ? action.modalConfig.component : action.modalConfig.message
            : undefined
        if (!component) {
            component = this.defaultActionModalConfig ? this.defaultActionModalConfig.component : undefined
        }
        switch (curdType) {
            case CURDAction.TYPE_UPDATE:
                this.modalService.open({
                    viewContainerRef: undefined,
                    component: component,
                    data: data,
                    title: action.name,
                }, (value) => { this.fetchData() }, (values) => {
                    debugger
                })
                break;
            case CURDAction.TYPE_CREATE:
                this.modalService.open({
                    viewContainerRef: undefined,
                    component: component,
                    data: data,
                    title: action.name,
                }, (value) => {
                    debugger
                    this.fetchData()
                }, (value) => {
                    debugger
                })
                break;
            case CURDAction.TYPE_READ:
                debugger
                this.fetchData()
                break;
            case CURDAction.TYPE_DELETE:
                this.modalService.open({
                    viewContainerRef: undefined,
                    component: component,
                    data: data,
                    title: action.name,
                }, (value) => { this.fetchData() }, () => { })
                break;
        }
    }
}

let dragingIndex = -1;

class BodyRow extends React.Component<any> {
    render() {
        const {
            isOver,
            connectDragSource,
            connectDropTarget,
            moveRow,
            ...restProps
        } = this.props;
        const style = { ...restProps.style, cursor: 'move' };

        let className = restProps.className;
        if (isOver) {
            if (restProps.index > dragingIndex) {
                className += ' drop-over-downward';
            }
            if (restProps.index < dragingIndex) {
                className += ' drop-over-upward';
            }
        }

        return connectDragSource(
            connectDropTarget(
                <tr
                    {...restProps}
                    className={className}
                    style={style}
                />
            )
        );
    }
}

const rowSource = {
    beginDrag(props) {
        dragingIndex = props.index;
        return {
            index: props.index,
        };
    },
};

const rowTarget = {
    drop(props, monitor) {
        debugger
        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;

        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
            return;
        }

        // Time to actually perform the action
        props.moveRow(dragIndex, hoverIndex);

        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        monitor.getItem().index = hoverIndex;
    },
};

const DragableBodyRow = DropTarget(
    'row',
    rowTarget,
    (connect, monitor) => ({
        connectDropTarget: connect.dropTarget(),
        isOver: monitor.isOver(),
    }),
)(
    DragSource(
        'row',
        rowSource,
        (connect) => {
            return {
                connectDragSource: connect.dragSource(),
            }
        },
    )(BodyRow),
);

const FormItem = Form.Item;
const EditableContext = React.createContext({});

// <tr {...props} />
const DragableRow = ({ form, index, ...props }) => (
    <EditableContext.Provider value={form}>
        <DragableBodyRow {...props} ></DragableBodyRow>
    </EditableContext.Provider>
);
const EditableRow = ({ form, index, ...props }) => (
    <EditableContext.Provider value={form}>
        <tr {...props} />
    </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);
const DragableFormRow = Form.create()(DragableRow);


class EditableCell extends React.Component<any> {
    state = {
        editing: false,
    }
    input
    form: any
    toggleEdit = () => {
        const editing = !this.state.editing;
        this.setState({ editing }, () => {
            if (editing) {
                this.input.focus();
            }
        });
    }

    save = (e) => {
        const { record, handleSave } = this.props;
        this.form.validateFields((error, values) => {
            if (error && error[e.currentTarget.id]) {
                return;
            }
            this.toggleEdit();
            handleSave({ ...record, ...values });
        });
    }

    render() {
        const { editing } = this.state;
        const {
            editable,
            dataIndex,
            title,
            record,
            index,
            handleSave,
            ...restProps
        } = this.props;
        return (
            <td {...restProps}>
                {editable ? (
                    <EditableContext.Consumer>
                        {(form: any) => {
                            this.form = form;
                            return (
                                editing ? (
                                    <FormItem style={{ margin: 0 }}>
                                        {form.getFieldDecorator(dataIndex, {
                                            rules: [{
                                                required: true,
                                                message: `${title} is required.`,
                                            }],
                                            initialValue: record[dataIndex],
                                        })(
                                            <Input
                                                ref={node => (this.input = node)}
                                                onPressEnter={this.save}
                                                onBlur={this.save}
                                            />
                                        )}
                                    </FormItem>
                                ) : (
                                        <div
                                            className="editable-cell-value-wrap"
                                            style={{ paddingRight: 24 }}
                                            onClick={this.toggleEdit}
                                        >
                                            {restProps.children}
                                        </div>
                                    )
                            );
                        }}
                    </EditableContext.Consumer>
                ) : restProps.children}
            </td>
        );
    }
}